interface FontsWeightNameMap {
    [key: string]: Array<string>| number;
}
export const fontsWeightNameMap: FontsWeightNameMap = {
  100: ['Thin', 'Hairline'],
  Thin: 100,
  Hairline: 100,
  200: ['Extra Light', 'Ultra Light'],
  ExtraLight: 200,
  UltraLight: 200,
  300: ['Light'],
  Light: 300,
  400: ['Regular', 'Normal'],
  Normal: 400,
  Regular: 400,
  500: ['Medium'],
  Medium: 500,
  600: ['Semi Bold', 'Demi Bold'],
  SemiBold: 600,
  DemiBold: 600,
  700: ['Bold'],
  Bold: 700,
  800: ['Extra Bold', 'Ultra Bold'],
  ExtraBold: 800,
  UltraBold: 800,
  900: ['Black', 'Heavy'],
  Black: 900,
  Heavy: 900,
};

const isName = (value: string) => Number.isNaN(parseFloat(value));

const getFontWeight = (weightOrName: string | number) => {
  return isName(weightOrName as string) ? fontsWeightNameMap[weightOrName] : weightOrName;
};

const getFontName = (weightOrName: string | number) => {
  return isName(weightOrName as string) ? weightOrName : fontsWeightNameMap[weightOrName];
};

export const weightNameTransformer = (weightOrName: string | number, name = false) => {
  return (name ? getFontName(weightOrName) : getFontWeight(weightOrName)) as string;
};
